import { create } from 'zustand';

export const useAuthStore = create((set) => ({
  user: JSON.parse(localStorage.getItem('gh_user') || 'null'),
  token: localStorage.getItem('gh_token') || null,
  
  login: (user, token) => {
    localStorage.setItem('gh_user', JSON.stringify(user));
    localStorage.setItem('gh_token', token);
    set({ user, token });
  },
  
  logout: () => {
    localStorage.removeItem('gh_user');
    localStorage.removeItem('gh_token');
    set({ user: null, token: null });
  }
}));

export const useBookingStore = create((set) => ({
  bookings: [],
  currentBooking: null,
  setBookings: (bookings) => set({ bookings }),
  setCurrentBooking: (booking) => set({ currentBooking: booking }),
  clearCurrentBooking: () => set({ currentBooking: null })
}));
